import { createFileRoute } from "@tanstack/react-router";

// /app/audit — workspace + agency-user view of the audit trail. The
// component (AuditLogList) ships in the .lazy sibling so the eager file
// stays minimal — same pattern as /app/jobs, /app/inbox, etc.
export const Route = createFileRoute("/app/audit/")({});
